import { IntegrationArtifact } from '../../models/integration-artifact';

export const artifactNameParser = (artifact: IntegrationArtifact): string => {
    if (artifact.backupType === 1) {
        const chunks = artifact.filePath.split('/');
        return chunks[chunks.length - 2];
    }
    if (artifact.backupType === 2) {
        const chunks = artifact.filePath.split('/');
        return chunks[chunks.length - 1];
    }
    return artifact.filePath;
};
